module.exports = __webpack_public_path__ + "static/media/small_planet.21c92e82.png";